<template>
	<div
		class="container margin-module"
		v-if="data && ((loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading')"
	>
		<div class="inner-content">
			<div v-if="data.search" :class="pageTheme ? 'theme--' + pageTheme : ''" class="search-area">
				<h3 class="search-title">Find member</h3>
				<div class="search-div">
					<input placeholder="Type to filter" type="search" name="membets-query" v-model="query" />
					<span class="icon" v-html="searchIcon"></span>
				</div>
			</div>
			<ul class="members-items" v-if="membersToDisplay && membersToDisplay.length">
				<li v-for="({ acf, id }, k) in membersToDisplay" :key="k" :class="'item item-' + id">
					<a v-if="acf" target="_blank" rel="nofollow" :href="acf.link" :title="acf.name">
						<WpImage :image="acf.logo" :lazy="false" />
					</a>
				</li>
			</ul>
			<div
				v-if="postItems && postItems.length && query && !membersToDisplay.length"
				class="not-found font--600 font-size--26 text-center"
			>
				Nothing found
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import WpImage from '@/components/elements/WpImage'
import { mapOrder } from '@/helpers'
import { search } from '@/icons'

export default {
	name: 'members-list',
	props: ['data'],
	data() {
		return {
			searchIcon: search('#222831'),
			query: '',
			postItems: [],
			loadingPostsStatus: 'loading',
		}
	},
	components: {
		WpImage,
	},
	computed: {
		...mapGetters(['pageTheme']),
		loadOpt() {
			const VM = this
			if (!VM.data) return false
			let opt = {
				type: 'members',
				include: VM.data.selected,
				order: 'asc',
				orderby: 'title',
				limit: VM.data.selected ? VM.data.selected.length : 250,
			}
			if (VM.data.category) opt.category = VM.data.category.join(',')
			return opt
		},
		membersToDisplay() {
			if (this.query) {
				const q = this.query.toLowerCase()
				return this.postItems.filter((e) => {
					return ~e.title.toLowerCase().indexOf(q)
				})
			} else return this.postItems
		},
	},
	mounted() {
		const VM = this
		if (!VM.data) return false
		VM.loadPosts()
	},
	methods: {
		...mapActions(['getPost']),
		loadPosts() {
			const VM = this
			if (!VM.loadOpt) {
				VM.loadingPostsStatus = 'failed'
				return false
			}

			VM.loadingPostsStatus = 'loading'
			return VM.getPost(VM.loadOpt).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					if (VM.data.selected) {
						VM.postItems = mapOrder(res.data.posts, VM.data.selected, 'id')
					} else {
						VM.postItems = res.data.posts
					}
				}
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-members {
	.search-area {
		border-radius: $radius;
		background-color: var(--gray);
		padding: 50px 25px;
		margin-bottom: 90px;
		@include mquery($tablet) {
			padding: 40px 30px;
			margin-bottom: 60px;
		}
		@include mquery($phone) {
			padding: 30px;
			margin-bottom: 25px;
		}
		&.theme {
			&--green {
				background-color: var(--greenLight);
				color: var(--green);
				input {
					color: inherit;
					&::placeholder {
						color: inherit;
					}
				}
				path {
					fill: var(--green);
				}
			}
			&--blue {
				background-color: var(--blueLight);
				color: var(--blue);
				input {
					color: inherit;
					&::placeholder {
						color: inherit;
					}
				}
				path {
					fill: var(--blue);
				}
			}
			&--red {
				background-color: var(--redLight);
				color: var(--red);
				input {
					color: inherit;
					&::placeholder {
						color: inherit;
					}
				}
				path {
					fill: var(--red);
				}
			}
			&--purple {
				color: var(--purple);
				background-color: var(--purpleLight);
				input {
					color: inherit;
					&::placeholder {
						color: inherit;
					}
				}
				path {
					fill: var(--purple);
				}
			}
		}
	}
	.search-div,
	.search-title {
		margin: 0 auto;
		max-width: $containerSmall;
		position: relative;
	}
	.search-title {
		margin-bottom: 20px;
	}
	.icon {
		position: absolute;
		right: 25px;
		z-index: 10;
		pointer-events: none;
		background-color: #fff;
		top: 50%;
		transform: translateY(-50%);
		svg {
			width: 25px;
			height: 25px;
		}
		@include mquery($tablet) {
			right: 20px;
		}
		@include mquery($phone) {
			right: 15px;
			svg {
				width: 20px;
				height: 20px;
			}
		}
	}
	input {
		position: relative;
		z-index: 5;
		min-height: 50px;
		padding: 10px 25px;
		border: none;
		box-shadow: none;
		border-radius: $radius;
		width: 100%;
		&::placeholder {
			font-weight: 600;
			color: var(--dark);
		}
		@include mquery($tablet) {
			min-height: 45px;
			padding: 8px 20px;
		}
		@include mquery($phone) {
			min-height: 40px;
			padding: 8px 17px;
		}
	}
	.members-items {
		margin: -25px;
		padding: 0;
		list-style: none;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		@include mquery($phone) {
			margin: -12px;
		}

		li {
			min-width: 20%;
			max-width: 20%;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			@include mquery($phone) {
				min-width: 33.33%;
				max-width: 33.33%;
			}

			a {
				padding: 25px;
				transition: transform 0.15s ease-in-out;
				&:hover {
					transform: scale(1.05);
				}
				@include mquery($phone) {
					padding: 12px;
				}
			}
			img {
				max-height: 140px;
				@include mquery($tablet) {
					max-height: 120px;
				}
				@include mquery($phone) {
					max-height: 90px;
				}
			}
			.wp-image-vue {
				text-align: center;
			}
		}
	}
}
</style>
